import { render, staticRenderFns } from "./SharedMediaFolderForm.vue?vue&type=template&id=19950474&"
import script from "./SharedMediaFolderForm.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports